<template>
  <div>
    <Header />
    <div class="about">
      <div class="about-showcase">
        <div>
          <h1>اِچ شاپی</h1>
          <h3>اولین مقصد خرید آنلاین در ایران</h3>
          <p>
            می‌خواستیم یک بازار مدرن بر پایه تکنولوژی بسازیم که اولین مرجع آنلاین و
            مورداعتماد «شما» باشد.
          </p>
        </div>
        <div>
          <img src="../assets/images/about/aboutus-1.png" alt="About-Us-One" />
        </div>
      </div>
      <div class="about-container">
        <div class="about-information">
          <h3>حرفی برای گفتن در تجارت الکترونیک</h3>
          <p class="about-honor">
            در سال ۱۳۸۵ با سرمایه اندکی شروع کردیم و حالا این عددها، سهم بزرگ ما از بازار
            تجارت الکترونیک را نشان می‌دهد.
          </p>
          <div class="about-information-show">
            <div>
              <i class="fas fa-store"></i>
              <p class="show-number">150,000+</p>
              <p>کسب و کار فروشنده</p>
              <a href="#"> فروشنده شوید </a>
              <span>></span>
            </div>
            <div>
              <i class="fas fa-clipboard-check"></i>
              <p class="show-number">4,500,000+</p>
              <p>تنوع کالایی</p>
              <a href="#"> کالا ها راببینید </a>
              <span>></span>
            </div>
            <div>
              <i class="fas fa-users"></i>
              <p class="show-number">30,000,000+</p>
              <p>بازدید یکتای ماهانه</p>
              <a href="#"> عضو دیجی کالا شوید </a>
              <span>></span>
            </div>
          </div>
        </div>
        <div class="about-value-one">
          <div>
            <p>چشم‌اندازمان کجاست؟</p>
            <p>
              چشم‌اندازمان این است که در صنعت تجارت الکترونیک، بهترین پلتفرم در خاورمیانه
              باشیم.
            </p>
          </div>
          <div>
            <p>ماموریتمان چیست؟</p>
            <p>
              استفاده از فناوری برای خلق تجربه خوشایند خرید برای مشتریان، توانمندسازی
              کسب‌وکارهای ایرانی و کمک به گذار آن‌ها به اقتصاد دیجیتال برای دستیابی به
              بازاری به‌وسعت ایران و خاورمیانه. همچنین رشد شایستگی‌های حرفه‌ای کارکنان
              مجموعه یکی از ماموریت‌های ماست.
            </p>
          </div>
        </div>
        <div class="about-value-two">
          <div class="about-pic-value">
            <h3>ارزش‌هایمان کدام است؟</h3>
            <div class="about-all-values">
              <div>
                <p>مشتری‌محوری</p>
                <p>
                  کنارتان هستیم، نه مقابلتان. فقط به فکر سود نیستیم. شما همیشه اولویت
                  دارید.
                </p>
              </div>
              <div>
                <p>شفافیت</p>
                <p>
                  همه‌چیز را صادقانه منعکس می‌کنیم تا با دیدی باز و آگاهانه تصمیم‌گیری
                  کنید.
                </p>
              </div>
              <div>
                <p>مسئولیت‌ پذیری</p>
                <p>
                  مسئولیت تمام کارهایمان را می‌پذیریم. اگر اشتباه کنیم، عذرخواهی و جبران
                  می‌کنیم.
                </p>
              </div>
              <div>
                <p>چابکی</p>
                <p>
                  سرعت، ویژگی اصلی کار ماست. چون وقت عزیز است و تنها یک بار زندگی می‌کنیم.
                </p>
              </div>
              <div>
                <p>نوآفرینی</p>
                <p>
                  برخی از نوآوری‌های ما، برای خودمان هم تازگی دارد و در کنار شما تازه
                  تجربه می‌کنیم.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="about-marketplace">
          <div>
            <img src="../assets/images/about/aboutus-5.png" alt="About-Us-Five" />
          </div>
          <div>
            <h1>به بازارگاه خوش آمدید!</h1>
            <p>
              در ۱۰ سال اول، فقط به شکل خرده‌فروشی آنلاین فعالیت می‌کردیم و اِچ شاپی تنها
              فروشنده در وب‌سایت خود بود. اما از سال ۱۳۹۶ مدل کسب‌وکارمان را به بازارگاه
              (Marketplace) تغییر دادیم. حالا اِچ شاپی هیچ تفاوتی با ۱۵۰ هزار فروشنده دیگر
              در این وب‌سایت ندارد و همه در کنار هم فعالیت می‌کنند. در آینده می‌خواهیم یک
              میلیون کسب‌وکار ایرانی را به بازار ۲۰۰ میلیون‌ نفری منطقه وصل کنیم.
            </p>
            <button>فروشنده دیجی کالا شوید</button>
          </div>
        </div>
        <div class="about-land">
          <p>یک زمین به اندازه یک سرزمین</p>
          <p>
            اِچ شاپی در زمینه انبارداری، در خاورمیانه حرفی برای گفتن دارد. این انبارها با
            مساحتی معادل ۹۵ هزار مترمربع، می‌توانند «۶ میلیون کالا» را در خود جای دهند و
            روزانه «۸۵۰ هزار کالا» را پردازش کنند. پراکندگی این انبارها در تمام استان‌های
            ایران باعث شده تا همه به صورت برابر امکان استفاده از اِچ شاپی را داشته باشند.
            افتتاح مراکز جدید پردازش سفارش، اِچ شاپی را به یکی از ظرفیت‌های بزرگ پردازش
            سفارش کالا در خاورمیانه تبدیل کرده است.
          </p>
        </div>
      </div>
      <div class="about-business">
        <div class="about-container">
          <div class="businessOne">
            <img src="../assets/images/about/1ad77944.svg" alt="SmileHShopy" />
            <h3>اولین آجر برای صنعت تجارت الکترونیک</h3>
            <p>
              با تغییر به مدل کسب‌وکار بازارگاه، اولین آجر را برای ساختن اکوسیستم تجارت
              الکترونیک در ایران گذاشتیم. افزودن محصولات و خدمات جدید و نوآوری در الگوهای
              کسب‌وکار، اینجا همیشه اولویت است. نوآوری‌هایی مانند فروش آنلاین مواد غذایی،
              محصولات تندمصرف، کتاب و محتوای دیجیتال. همچنین خدمات پرداخت الکترونیک،
              تبلیغات دیجیتال، خدمات ابری و خریدوفروش در بستر شبکه اجتماعی را راه انداختیم
              تا زنجیره ارزشمان را کامل کنیم.
            </p>
          </div>
          <div class="businessTwo">
            <div>
              <img src="../assets/images/about/45d22c5e.svg" alt="" />
              <h5>اِچ شاپی</h5>
              <p class="define-business">مارکت پلیس</p>
            </div>
            <div>
              <img src="../assets/images/about/57a77d33.svg" alt="" />
              <h5>
                اِچ شاپی استایل
                <i class="far fa-clock"></i>
              </h5>
              <p class="define-business">فروشگاه آنلاین مد و پوشاک</p>
            </div>
            <div>
              <img src="../assets/images/about/fba197d5.svg" alt="" />
              <h5>
                اِچ شاپی جت
                <i class="far fa-clock"></i>
              </h5>
              <p class="define-business">کالاهای تند مصرف</p>
            </div>
            <div>
              <img src="../assets/images/about/49e9f1ae.svg" alt="" />
              <h5>
                پیندو
                <i class="far fa-clock"></i>
              </h5>
              <p class="define-business">ثبت آگهی و ارائه خدمات</p>
            </div>
            <div>
              <img src="../assets/images/about/258438b7.svg" alt="" />
              <h5>
                اِچ شاپی مگ
                <i class="far fa-clock"></i>
              </h5>
              <p class="define-business">مجله آنلاین فناوری و سبک زندگی</p>
            </div>
            <div>
              <img src="../assets/images/about/ab32326f.svg" alt="" />
              <h5>
                فیبیدو
                <i class="far fa-clock"></i>
              </h5>
              <p class="define-business">فروشگاه کتاب و محتوای دیجیتال</p>
            </div>
          </div>
          <div class="businessThree">
            <div>
              <img src="../assets/images/about/050b374b.svg" alt="" />
              <h5>
                اکمدا
                <i class="far fa-clock"></i>
              </h5>
              <p class="define-business">معامله مبتی بر شبکه اجتماعی</p>
            </div>
            <div>
              <img src="../assets/images/about/48cbffa2.svg" alt="" />
              <h5>
                اِچ پی
                <i class="far fa-clock"></i>
              </h5>
              <p class="define-business">پرداخت الکترونیک هوشمند</p>
            </div>
            <div>
              <img src="../assets/images/about/f865e321.svg" alt="" />
              <h5>
                اِچ نکست
                <i class="far fa-clock"></i>
              </h5>
              <p class="define-business">مرکز نوآوری اِچ شاپی</p>
            </div>
            <div>
              <img src="../assets/images/about/810b3f9b.svg" alt="" />
              <h5>
                اِچ اکسپرس
                <i class="far fa-clock"></i>
              </h5>
              <p class="define-business">شبکه هوشمند لجستیکی</p>
            </div>
            <div>
              <img src="../assets/images/about/ee32909d.svg" alt="" />
              <h5>
                اسمارتک
                <i class="far fa-clock"></i>
              </h5>
              <p class="define-business">راهکارهای تکنولوژی محور بازاریابی</p>
            </div>
          </div>
        </div>
      </div>
      <div class="about-guide">
        <div class="about-container">
          <div class="about-guide-content">
            <div>
              <img src="../assets/images/about/45d22c5e.svg" alt="HOWtoKnowEchShopy" />
              <p>
                چه فروشنده اِچ شاپی باشید، چه خریدار، اِچ شاپی هویت خود را از شما وام
                گرفته است.
              </p>
            </div>
            <div>
              <button>راهنمای هویت بصری دیجی کالا ></button>
            </div>
          </div>
        </div>
      </div>
      <div class="about-hiring">
        <div class="about-container">
          <div class="about-hiring-content">
            <img src="../assets/images/about/8373a029.svg" alt="forHiring" />
            <h3>هیچ مرزی نیست، آماده‌اید؟</h3>
            <p>
              اِچ شاپی یک جامعه است. جامعه‌ای تشکیل‌شده از ۸۵۰۰ متخصص در زمینه‌های مختلف.
              از تکنولوژی گرفته تا حقوقی و عملیات. همچنین ۴۰۰ هزار نفر به‌صورت غیرمستقیم
              از طریق اِچ شاپی کسب درآمد می‌کنند. شما هم می‌توانید عضو این جامعه باشید و
              رویاهای خودتان را بسازید. آماده‌اید؟
            </p>
            <button>موقعیت های شغلی را ببینید</button>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  name: "About",
};
</script>
